<div class="ts-card">
    <div class="page-header">
        <h2 class="ts-card-title page-title">Today's Orders</h2>
        <button class="btn-primary" type="button" (click)="loadData()">
            <fa-icon [icon]="faRotate"></fa-icon>
            Refresh
        </button>
    </div>
    <ng-container *ngIf="!loading && searchExecuted">
        <ng-container *ngIf="totalRecords > 0; else noRecordsFound">
            <table class="ts-table">
                <thead>
                    <tr>
                        <th class="text-right-numeric header-vertical-border">Account ID</th>
                        <th class="text-right-numeric header-vertical-border">Order #</th>
                        <th class="header-vertical-border">Symbol</th>
                        <th class="text-right-numeric header-vertical-border">Price Limit</th>
                        <th class="text-right-numeric header-vertical-border">Quantity</th>
                        <th class="header-vertical-border">Side</th>
                        <th class="header-vertical-border">Type</th>
                        <th class="header-vertical-border">Status</th>
                        <th class="header-vertical-border" style="min-width: 200px;">Time Stamp (ET)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let order of pagedElements$ | async">
                        <td class="text-right-numeric">
                            <a [routerLink]="['/account/account-detail', order.accountId]">{{ order.accountId }}</a>
                        </td>
                        <td class="text-right-numeric">{{ order.orderId }}</td>
                        <td>{{ order.symbol }}</td>
                        <td class="text-right-numeric">{{ order.priceLimit | currency:'USD':'symbol':'1.2-2' }}</td>
                        <td class="text-right-numeric">{{ order.quantity }}</td>
                        <td>{{ order.side }}</td>
                        <td>{{ order.type }}</td>
                        <td>{{ order.status }}</td>
                        <td style="min-width: 200px;">{{ parseDatetimeToEST(order.timestamp) }}</td>
                    </tr>
                </tbody>
            </table>
            <app-paginator *ngIf="totalRecords > 0" [length]="totalRecords" [pageSize]="pageSize"
                [pageSizeOptions]="[10, 25, 100]" (page)="pageChangeEvent($event)">
            </app-paginator>

            <div *ngIf="totalRecords > 0" style="text-align: center; margin-top: 20px;">
                <a [routerLink]="['/allocate/allocation-list']">
                    <button class="btn-primary">Unallocated Trades</button>
                </a>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #noRecordsFound>
        <app-empty-state
            [icon]="faReceipt"
            headline="No orders today"
            hint="No orders have been placed today. Use Refresh to check again."></app-empty-state>
    </ng-template>
</div>
